import { render } from "./add-country.vue?vue&type=template&id=4076378a&lang=html"
import script from "./add-country.vue?vue&type=script&lang=js"
export * from "./add-country.vue?vue&type=script&lang=js"

import "./add-country.vue?vue&type=style&index=0&id=4076378a&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__